import { render, staticRenderFns } from "./CustomFootwearCustomizationModal.vue?vue&type=template&id=a95195ea&"
import script from "./CustomFootwearCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./CustomFootwearCustomizationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomFootwearCustomizationModal.vue?vue&type=style&index=0&id=a95195ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports